Ext.define('SA.view.sidebar.business.BusinessSearchList', {
    alias: 'widget.business-search-list',
    extend: 'SA.view.sidebar.SidebarList',

    items: [
        {
            handler: 'onAdvancedSearchClick',
            text: 'Use advanced search'
        }, {
            handler: 'onBrowseCategoriesClick',
            text: 'Browse business categories'
        }
    ],

    onAdvancedSearchClick() {
        Ext.widget({
            xtype: 'business-search-editor',
            autoShow: true,

            callback: search => {
                this.up('[useBusinessSearch]').useBusinessSearch(search);
            },

            listeners: {
                destroy: () => {
                    this.setSelected(null);
                }
            }
        });
    },

    onBrowseCategoriesClick(item) {
        var menu = this.browseCategoriesMenu;

        if (menu && menu.wasRecentlyVisible()) {
            this.setSelected(null);

            return;
        }

        if (!menu) {
            menu = this.browseCategoriesMenu = Ext.widget({
                xtype: 'browse-business-codes',
                alignment: 'right',
                positionEl: this.getItemEl(item),
                target: this,
                track: true,

                listeners: {
                    hide: () => {
                        if (this.getSelected() === item) {
                            this.setSelected(null);
                        }
                    },

                    select: async (menu, type, code) => {
                        var search = await SA.data.BusinessSearches.createForCode({type, code});

                        this.up('[useBusinessSearch]').useBusinessSearch(search);
                    }
                }
            });
        }

        menu.setCountry(this.country);

        menu.show();
    },

    setCountry(country) {
        this.country = country;
    }
});